import { Button, Form, message } from 'antd';
import { Integration } from '../../../models';
import { IntegrationSchedulesForm } from './integration-schedules-form';
import { useEffect } from 'react';
import { apiClient } from '../../../utils';

export function IntegrationImportCalendarPage(props: { integration?: Integration }) {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    apiClient
      .put(`integrations/${props.integration?.id}/schedule`, {
        schedule: values.schedule,
        integrationId: props.integration?.id,
      })
      .then(() => {
        message.success('İşlem başarılı');
      })
      .catch((reason: any) => {
        message.error('İşlem başarısız');
      });
  };

  useEffect(() => {
    form.setFieldsValue({
      schedule: props.integration?.schedule,
    });
  }, [form, props.integration]);

  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item name={'schedule'}>
          <IntegrationSchedulesForm integrationType='import' />
        </Form.Item>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
          }}
        >
          <Button type="primary" htmlType="submit">
            Kaydet
          </Button>
        </div>
      </Form>
    </div>
  );
}
